import LazyLoadImages from './modules/lazyLoadImages';
import Selects from './components/selects';
import { bindLookBookItems } from './modules/colourChipPopup';

function checkUrl() {

    if (window.location.search != '') {
        var urlParams = new URLSearchParams(window.location.search),
            itemIndex = urlParams.get('itemIndex'),
            theItem = document.querySelector('.look-book-item[data-lookbook-index="' + itemIndex + '"]');

        if (theItem) {
            setTimeout(function () {
                theItem.click();
            }, 500);
        }
    }
}

function fetchAndSwap(url, pushState) {
    if (!url) return;

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.text(); })
        .then(function (html) {
            var target = document.getElementById('lookbook-content');
            if (target) target.outerHTML = html;
            if (pushState) window.history.pushState({ url: url }, '', url);
            Selects();
            LazyLoadImages();
            bindLookBookItems();
            checkUrl();
        })
        .catch(function (err) {
            console.error('Lookbook filter fetch failed:', err);
        });
}

document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('.look-book-form select[data-ajax-filter]')) return;
    var opt = sel.options[sel.selectedIndex];
    fetchAndSwap(opt && opt.dataset ? opt.dataset.src : null, true);
});

window.addEventListener('popstate', function (e) {
    fetchAndSwap((e.state && e.state.url) || window.location.href, false);
});

checkUrl();
